const routes = [
    {
        path: '/student/programs/medicine/groups',
        component: () => import('../pages/MedicineGroups'),
        meta: {
            isAuthenticated: true,
            permission: 'studentprogram_medicinegroup'
        }
    },
    {
        path: '/student/programs/update-classes',
        component: () => import('../pages/UpdateClassesJob'),
        meta: {
            isAuthenticated: true,
            permission: 'studentprogram_updateclasses'
        }
    },
    {
        path: '/student/programs/class-success',
        component: () => import('../pages/ClassSuccess'),
        meta: {
            isAuthenticated: true,
            permission: 'studentprogram_classsuccess'
        }
    },
    {
        path: '/student/programs/graduation-success',
        component: () => import('../pages/GraduationSuccess'),
        meta: {
            isAuthenticated: true,
            permission: 'studentprogram_graduatesuccess'
        }
    },
    {
        path: '/student/programs/graduation-requirement-report',
        component: () => import('../pages/GraduationRequirementReport'),
        meta: {
            isAuthenticated: true,
            permission: 'studentprogram_graduationrequirementreport'
        }
    },
    {
        path: '/student/programs/:id/slots',
        component: () => import('../pages/slots/Index'),
        meta: {
            isAuthenticated: true,
            permission: 'studentprogram_studentslot'
        },
        component_full_path: 'studentProgram/pages/slots/Index'
    },
    {
        path: '/student/programs/:id/slots/edit',
        component: () => import('../pages/slots/Edit'),
        meta: {
            isAuthenticated: true,
            permission: 'studentslot_update'
        },
        component_full_path: 'studentProgram/pages/slots/Edit'
    },
    {
        path: '/my-slots',
        component: () => import('../pages/slots/Index'),
        meta: {
            isAuthenticated: true,
            isStudent: true,
            permission: "studentprogram_studentslot"
        }
    },
    {
        path: '/my-requests/:tab?',
        component: () => import('../pages/Requests'),
        meta: {
            isAuthenticated: true,
            //isStudent: true
        },
        component_full_path: 'studentProgram/pages/Requests'
    }
]

export default routes;
